/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { CarrierService } from "./CarrierService";
import {
  CarrierServiceFromJSON,
  CarrierServiceFromJSONTyped,
  CarrierServiceToJSON,
  CarrierServiceToJSONTyped,
} from "./CarrierService";

/**
 *
 * @export
 * @interface CreateExperimentRunRequest
 */
export interface CreateExperimentRunRequest {
  /**
   *
   * @type {string}
   * @memberof CreateExperimentRunRequest
   */
  name?: string | null;
  /**
   *
   * @type {string}
   * @memberof CreateExperimentRunRequest
   */
  purpose?: string | null;
  /**
   *
   * @type {Array<CarrierService>}
   * @memberof CreateExperimentRunRequest
   */
  selectedCarriers?: Array<CarrierService> | null;
  /**
   *
   * @type {Array<string>}
   * @memberof CreateExperimentRunRequest
   */
  shipmentIds?: Array<string> | null;
  /**
   *
   * @type {number}
   * @memberof CreateExperimentRunRequest
   */
  maxConcurrentJobs: number;
  /**
   *
   * @type {number}
   * @memberof CreateExperimentRunRequest
   */
  waitTimeBetweenBatchesMs: number;
}

/**
 * Check if a given object implements the CreateExperimentRunRequest interface.
 */
export function instanceOfCreateExperimentRunRequest(
  value: object,
): value is CreateExperimentRunRequest {
  if (
    !("maxConcurrentJobs" in value) ||
    value["maxConcurrentJobs"] === undefined
  )
    return false;
  if (
    !("waitTimeBetweenBatchesMs" in value) ||
    value["waitTimeBetweenBatchesMs"] === undefined
  )
    return false;
  return true;
}

export function CreateExperimentRunRequestFromJSON(
  json: any,
): CreateExperimentRunRequest {
  return CreateExperimentRunRequestFromJSONTyped(json, false);
}

export function CreateExperimentRunRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CreateExperimentRunRequest {
  if (json == null) {
    return json;
  }
  return {
    name: json["name"] == null ? undefined : json["name"],
    purpose: json["purpose"] == null ? undefined : json["purpose"],
    selectedCarriers:
      json["selectedCarriers"] == null
        ? undefined
        : (json["selectedCarriers"] as Array<any>).map(CarrierServiceFromJSON),
    shipmentIds: json["shipmentIds"] == null ? undefined : json["shipmentIds"],
    maxConcurrentJobs: json["maxConcurrentJobs"],
    waitTimeBetweenBatchesMs: json["waitTimeBetweenBatchesMs"],
  };
}

export function CreateExperimentRunRequestToJSON(
  json: any,
): CreateExperimentRunRequest {
  return CreateExperimentRunRequestToJSONTyped(json, false);
}

export function CreateExperimentRunRequestToJSONTyped(
  value?: CreateExperimentRunRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    name: value["name"],
    purpose: value["purpose"],
    selectedCarriers:
      value["selectedCarriers"] == null
        ? undefined
        : (value["selectedCarriers"] as Array<any>).map(CarrierServiceToJSON),
    shipmentIds: value["shipmentIds"],
    maxConcurrentJobs: value["maxConcurrentJobs"],
    waitTimeBetweenBatchesMs: value["waitTimeBetweenBatchesMs"],
  };
}
